import { createContext, useContext } from "react";

/**
 * What the connection is doing, when it is worth saying ("Offline",
 * "Connecting…"), or `null`. Headers show it in place of their quiet
 * secondary line, so it never takes space of its own and nothing moves
 * when it comes or goes.
 */
export const MobileStatusContext = createContext<string | null>(null);

export function useMobileStatus(): string | null {
  return useContext(MobileStatusContext);
}
